// ExperimentsView.js
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import MainPanelContent from "../components/MainPanelContent";
import { SURFACE, HAIRLINE, RADIUS, SHADOW_SM } from "../../../theme/tokens";

import WorkspacesSection from "./workspaces/WorkspacesSection";
import BatchJobsSection from "./jobs/BatchJobsSection";

// Each experiment group lives in its own framed surface card so the two
// sections read as distinct, organized panels rather than a single scroll.
const sectionCardSx = {
  bgcolor: SURFACE,
  border: `1px solid ${HAIRLINE}`,
  borderRadius: `${RADIUS.md}px`,
  boxShadow: SHADOW_SM,
  p: { xs: 2, sm: 2.5, md: 3 },
};

const ExperimentsView = ({ onWorkspaceCreation, onJobSubmit }) => (
  <MainPanelContent title="My Experiments" headerMb={1} contentGap={3}>
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 3, width: "100%" }}
    >
      <Box component="section" sx={sectionCardSx}>
        <WorkspacesSection onWorkspaceCreation={onWorkspaceCreation} />
      </Box>
      <Box component="section" sx={sectionCardSx}>
        <BatchJobsSection onJobSubmit={onJobSubmit} />
      </Box>
    </Box>
  </MainPanelContent>
);

ExperimentsView.propTypes = {
  onWorkspaceCreation: PropTypes.func,
  onJobSubmit: PropTypes.func,
};

export default ExperimentsView;
